/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribute`)
};

const zh_hans1_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贡献`)
};

const zh_hant1_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貢獻`)
};

const fr_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuer`)
};

const de_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitwirken`)
};

const ja_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貢献する`)
};

const ko_footer_contribute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기여하기`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_contribute = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_contribute(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_contribute", locale)
	if (locale === "en") return en_footer_contribute(inputs)
	if (locale === "zh-Hans") return zh_hans1_footer_contribute(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_contribute(inputs)
	if (locale === "fr") return fr_footer_contribute(inputs)
	if (locale === "de") return de_footer_contribute(inputs)
	if (locale === "ja") return ja_footer_contribute(inputs)
	return ko_footer_contribute(inputs)
};